<template>

  <kendo-window ref="codeMasterWindowRef"
                :title="saveMode==='INSERT'?'그룹코드추가' :'그룹코드수정'"
                :modal="true"
                :width="'982px'"
                @open="getCodeMasterDetail"
                @close="clearCodeMasterWindowValue"
                style="z-index: 10004; transform: scale(1); opacity: 1; display:none;">
    <form id="codeMasterInfoForm" v-kendo-validator @submit.prevent="">
      <div class="pwindow">
        <div class="k-window-content k-content">
          <ul class="filter_list">
            <li v-if="codeMode==='COMPANY'">
              <dd>
                <label>회사
                  <span class="forg">*</span>
                </label>
                <ul v-if="saveMode==='INSERT'" class="w70">
                  <li>
                    <dropdown-company ref="windowCompanyDropdownRef"></dropdown-company>
                  </li>
                </ul>
                <ul v-else>
                  <li>{{codeMasterInfo.cmpyNm}}</li>
                </ul>
              </dd>
            </li>
            <li v-else-if="codeMode==='SOLUTION'">
              <dd>
                <label>솔루션
                  <span class="forg">*</span>
                </label>
                <ul v-if="saveMode==='INSERT'" class="w70">
                  <li>
                    <dropdown-solution ref="windowSolutionDropdownRef"></dropdown-solution>
                  </li>
                </ul>
                <ul v-else>
                  <li>{{codeMasterInfo.solNm}}</li>
                </ul>
              </dd>
              <dd>
                <label>회사
                  <span class="forg">*</span>
                </label>
                <ul class="w70">
                  <li>
                    <dropdown-company ref="windowCompanyDropdownRef"></dropdown-company>
                  </li>
                </ul>
              </dd>
            </li>
            <li>
              <dd>
                <label>그룹코드
                  <span class="forg">*</span>
                </label>
                <ul v-if="saveMode==='INSERT'" class="w60">
                  <kendo-maskedtextbox
                          ref="cdGrupRef"
                          name="cdGrup"
                          maxlength="20"
                          :style="'width: 60%;'"
                          validationMessage="그룹코드을 입력하세요"
                          required
                  >
                  </kendo-maskedtextbox>
                  <span class="w60">
                    <button class="mid_btn orange" @click="onClickCdGrupDuplicateCheck">중복체크</button>
                  </span>
                </ul>
                <ul v-else>
                  <li>{{codeMasterInfo.cdGrup}}</li>
                </ul>
              </dd>
              <dd>
                <label>그룹코드명
                  <span class="forg">*</span>
                </label>
                <ul class="w70">
                  <kendo-maskedtextbox
                          ref="cdGrupNmRef"
                          name="cdGrupNm"
                          maxlength="500"
                          :value="codeMasterInfo.cdGrupNm"
                          :style="'width: 100%;'"
                          validationMessage="그룹코드명을 입력하세요"
                          required
                  >
                  </kendo-maskedtextbox>
                </ul>
              </dd>
            </li>
            <li>
              <dd>
                <label>설명
                  <span class="forg">*</span>
                </label>
                <ul class="w70">
                  <li class="w50 fl mr5">
                    <kendo-maskedtextbox
                            ref="cdDescRef"
                            name="cdDesc"
                            maxlength="1000"
                            :value="codeMasterInfo.cdDesc"
                            :style="'width: 100%;'"
                            validationMessage="설명 입력하세요"
                            required
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
            </li>
            <li>
              <dd>
                <label>사용여부
                  <span class="forg">*</span>
                </label>
                <ul class="w70">
                  <li class="w80">
                    <kendo-switch :checked="codeMasterInfo.useYn === 'Y' || saveMode ==='INSERT'" ref="useYnRef"></kendo-switch>
                  </li>
                </ul>
              </dd>
              <dd>
                <label>조회순서
                  <span class="forg">*</span>
                </label>
                <ul class="w70">
                  <kendo-numerictextbox
                          ref="seqNoRef"
                          name="seqNo"
                          :min="1"
                          :max="999"
                          :format="'n0'"
                          :style="'width: 100%;'"
                          :value="codeMasterInfo.seqNo === undefined ? 1 : codeMasterInfo.seqNo"
                          validationMessage="조회순서를 입력하세요"
                          required
                  >
                  </kendo-numerictextbox>
                </ul>
              </dd>
            </li>
            <li>
              <label>다국어정보
                <span class="forg">*</span>
              </label>
              <ul class="w70">
                <li>
                </li>
              </ul>
            </li>
            <li>
              <dd>
                <label>영어
                  <span class="forg">*</span>
                </label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                            ref="cdGrupEnRef"
                            name="cdGrupEn"
                            maxlength="1000"
                            :value="codeMasterInfo.cdGrupEn"
                            :style="'width: 100%;'"
                            validationMessage="영어명를 입력하세요"
                            required
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
            </li>
            <li>
              <dd>
                <label>중국어
                  <span class="forg">*</span>
                </label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                            ref="cdGrupZhRef"
                            name="cdGrupZh"
                            maxlength="1000"
                            :value="codeMasterInfo.cdGrupZh"
                            :style="'width: 100%;'"
                            validationMessage="중국어명를 입력하세요"
                            required
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
            </li>

            <li>
              <dd>
                <label>베트남어
                  <span class="forg">*</span>
                </label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                            ref="cdGrupVnRef"
                            name="cdGrupVn"
                            maxlength="1000"
                            :value="codeMasterInfo.cdGrupVn"
                            :style="'width: 100%;'"
                            validationMessage="베트남어명를 입력하세요"
                            required
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
            </li>
            <li>
              <dd>
                <label>일본어
                  <span class="forg">*</span>
                </label>
                <ul class="w70">
                  <li>
                    <kendo-maskedtextbox
                            ref="cdGrupJpRef"
                            name="cdGrupJp"
                            maxlength="1000"
                            :value="codeMasterInfo.cdGrupJp"
                            :style="'width: 100%;'"
                            validationMessage="일본어명를 입력하세요"
                            required
                    >
                    </kendo-maskedtextbox>
                  </li>
                </ul>
              </dd>
            </li>
          </ul>
        </div>
        <div class="button_wrap_area">
          <ul>
            <li v-if="saveMode==='INSERT'">
              <button class="large_btn orange" @click="onClickCodeMasterSave">저장</button>
            </li>
            <li v-if="saveMode==='UPDATE'">
              <button class="large_btn orange" @click="onClickCodeMasterSave">수정</button>
            </li>
            <li>
              <button class="large_btn" @click="onClickCodeMasterClose">취소</button>
            </li>
          </ul>
        </div>
      </div>
    </form>
  </kendo-window>
</template>

<script>
  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'
  import DropdownCompany from '@/components/admin/DropdownCompany'
  import DropdownSolution from '@/components/admin/DropdownSolution'

  export default {
    name      : 'CodeMasterWindow',
    components: {
      DropdownCompany,
      DropdownSolution,
    },
    props     : {
      codeMode: {
        default: null,
      },
      cmpyCd  : {
        default: null,
      },
      solCd   : {
        default: null,
      },
      cdGrup  : {
        default: null,
      },
    },
    data      : function () {
      return {
        windowCmpyCd  : '',
        windowSolCd   : '',
        windowCdGrup  : '',
        codeMasterInfo: {},
        saveMode      : 'INSERT',
        duplicateCheck: false,
      }
    },
    methods   : {
      getCodeMasterDetail: function () {
        this.windowCmpyCd = this.$props.cmpyCd
        this.windowSolCd = this.$props.solCd
        this.windowCdGrup = this.$props.cdGrup
        if (this.saveMode === 'UPDATE') {
          const vue = this
          const loginUserToken = sessionStorage.lutk

          let param = {}
          if (vue.codeMode === 'COMPANY') {
            param = {
              loginUserToken: loginUserToken,
              codeMode      : vue.codeMode,
              cmpyCd        : this.windowCmpyCd,
              cdGrup        : this.windowCdGrup,
            }
          } else if (vue.codeMode === 'SOLUTION') {
            param = {
              loginUserToken: loginUserToken,
              codeMode      : vue.codeMode,
              solCd         : this.windowSolCd,
              cdGrup        : this.windowCdGrup,
            }
          }

          ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/code/masterCodeDetail.json`, param).then(function (response) {
              if (response.data.resultStatus.messageCode === '2000') {
                let changeResultData = response.data.resultData

                vue.codeMasterInfo = changeResultData

                vue.$refs.cdGrupNmRef.kendoWidget().value(vue.codeMasterInfo.cdGrupNm)
                vue.$refs.cdDescRef.kendoWidget().value(vue.codeMasterInfo.cdDesc)
                vue.$refs.useYnRef.kendoWidget().value(vue.codeMasterInfo.useYn ? 'Y' : 'N')
                vue.$refs.seqNoRef.kendoWidget().value(vue.codeMasterInfo.seqNo)
                vue.$refs.cdGrupEnRef.kendoWidget().value(vue.codeMasterInfo.cdGrupEn)
                vue.$refs.cdGrupZhRef.kendoWidget().value(vue.codeMasterInfo.cdGrupZh)
                vue.$refs.cdGrupVnRef.kendoWidget().value(vue.codeMasterInfo.cdGrupVn)
                vue.$refs.cdGrupJpRef.kendoWidget().value(vue.codeMasterInfo.cdGrupJp)

              } else {
                kendo.alert(response.data.resultStatus.messageText)
              }
            },
          )
        } else if (this.saveMode === 'INSERT' && this.codeMode === 'COMPANY') {
          this.$refs.windowCompanyDropdownRef.$refs.cmpyCdRef.kendoWidget().setOptions({ optionLabel: '선택' })
          this.$refs.windowCompanyDropdownRef.$refs.cmpyCdRef.kendoWidget().value(this.windowCmpyCd)
        } else if (this.saveMode === 'INSERT' && this.codeMode === 'SOLUTION') {
          this.$refs.windowCompanyDropdownRef.$refs.cmpyCdRef.kendoWidget().setOptions({ optionLabel: '선택' })
          this.$refs.windowSolutionDropdownRef.$refs.solCdRef.kendoWidget().setOptions({ optionLabel: '선택' })
          this.$refs.windowSolutionDropdownRef.$refs.solCdRef.kendoWidget().value(this.windowSolCd)
        }
      },

      onClickCdGrupDuplicateCheck: function () {
        const vue = this
        const cmpyCd = vue.$refs.windowCompanyDropdownRef.$refs.cmpyCdRef.kendoWidget().value()
        const solCd = vue.codeMode === 'SOLUTION' ? vue.$refs.windowSolutionDropdownRef.$refs.solCdRef.kendoWidget().value() : ''
        const cdGrup = vue.$refs.cdGrupRef.kendoWidget().value()

        const param = {
          loginUserToken: sessionStorage.lutk,
          codeMode      : this.codeMode,
          cmpyCd        : cmpyCd,
          solCd         : solCd,
          cdGrup        : cdGrup,
        }

        if (vue.codeMode === 'SOLUTION' && (solCd === undefined || solCd === '')) {
          kendo.alert('솔루션을 선택해 주십시요.')
          return false
        }

        if (cmpyCd === undefined || cmpyCd === '') {
          kendo.alert('회사를 선택해 주십시요.')
          return false
        }

        if (cdGrup === undefined || cdGrup === '') {
          kendo.alert('그룹코드를 입력해 주십시요.')
          return false
        }

        let url = `${ApiConfig.platformDomain}/v1/ebmp/admin/code/checkMasterCode.json`
        ApiUtil.post(url, param).then(response => {
          if (response.data.resultStatus.messageCode === '2000') {
            kendo.alert('사용 가능한 그룹코드입니다.')
            vue.duplicateCheck = true
          } else {
            if (response.data.resultStatus.messageCode !== '4000') {
              kendo.alert('중복된 그룹코드입니다')
              vue.duplicateCheck = false
            } else {
              // 실패 - 시스템 오류
              kendo.alert(response.data.resultStatus.messageText)
              return false
            }
          }
        })
      },
      onClickCodeMasterSave      : function () {

        const vue = this
        const refs = vue.$refs
        let validator = vue.kendoValidator
        let confirmKeyword = (vue.saveMode === 'UPDATE' ? '수정' : '추가')

        if (!vue.duplicateCheck && vue.saveMode === 'INSERT') {
          kendo.alert('코드 중복확인을 해주세요.')
          return false
        }

        if (validator.validate()) {
          kendo.confirm('그룹코드를 ' + confirmKeyword + '하시겠습니까?').done(function () {

              let param = {}
              if (vue.codeMode === 'COMPANY') {
                param = {
                  loginUserToken: sessionStorage.lutk,
                  codeMode      : vue.codeMode,
                  cmpyCd        : vue.saveMode === 'UPDATE' ? vue.codeMasterInfo.cmpyCd : refs.windowCompanyDropdownRef.$refs.cmpyCdRef.kendoWidget().value(),
                  cdGrup        : vue.saveMode === 'UPDATE' ? vue.codeMasterInfo.cdGrup : refs.cdGrupRef.kendoWidget().value(),
                  cdGrupNm      : refs.cdGrupNmRef.kendoWidget().value(),
                  cdDesc        : refs.cdDescRef.kendoWidget().value(),
                  useYn         : refs.useYnRef.kendoWidget().value() ? 'Y' : 'N',
                  seqNo         : refs.seqNoRef.kendoWidget().value(),
                  cdGrupEn      : refs.cdGrupEnRef.kendoWidget().value(),
                  cdGrupZh      : refs.cdGrupZhRef.kendoWidget().value(),
                  cdGrupVn      : refs.cdGrupVnRef.kendoWidget().value(),
                  cdGrupJp      : refs.cdGrupJpRef.kendoWidget().value(),
                }
              } else if (vue.codeMode === 'SOLUTION') {
                param = {
                  loginUserToken: sessionStorage.lutk,
                  codeMode      : vue.codeMode,
                  solCd         : vue.saveMode === 'UPDATE' ? vue.codeMasterInfo.solCd : refs.windowSolutionDropdownRef.$refs.solCdRef.kendoWidget().value(),
                  cmpyCd        : vue.saveMode === 'UPDATE' ? vue.codeMasterInfo.cmpyCd : refs.windowCompanyDropdownRef.$refs.cmpyCdRef.kendoWidget().value(),
                  cdGrup        : vue.saveMode === 'UPDATE' ? vue.codeMasterInfo.cdGrup : refs.cdGrupRef.kendoWidget().value(),
                  cdGrupNm      : refs.cdGrupNmRef.kendoWidget().value(),
                  cdDesc        : refs.cdDescRef.kendoWidget().value(),
                  useYn         : refs.useYnRef.kendoWidget().value() ? 'Y' : 'N',
                  seqNo         : refs.seqNoRef.kendoWidget().value(),
                  cdGrupEn      : refs.cdGrupEnRef.kendoWidget().value(),
                  cdGrupZh      : refs.cdGrupZhRef.kendoWidget().value(),
                  cdGrupVn      : refs.cdGrupVnRef.kendoWidget().value(),
                  cdGrupJp      : refs.cdGrupJpRef.kendoWidget().value(),
                }
              }

              vue.$Progress.start()
              ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/code/upsertMaster.json`, param).then(response => {
                if (response.data === undefined || response.data.resultStatus === undefined) {
                  kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
                  vue.$Progress.fail()
                  return false

                }
                if (response.data.resultStatus.messageCode !== '2000') {
                  kendo.alert(response.data.resultStatus.messageText)
                  vue.$Progress.fail()
                  return false
                }

                kendo.alert(confirmKeyword + '되었습니다.')

                // progressbar 종료
                vue.$Progress.finish()
                // 창 닫고 그룹코드 목록 리프레시
                vue.onClickCodeMasterClose()
              })
            },
          )
        } else {
          let errors = validator.errors()
          kendo.alert(errors[0])
        }
      },
      onClickCodeMasterClose     : function () {
        this.clearCodeMasterWindowValue()
        this.$refs.codeMasterWindowRef.kendoWidget().close()
      },
      clearCodeMasterWindowValue : function () {

        if (this.$refs.windowCompanyDropdownRef !== undefined) {
          this.$refs.windowCompanyDropdownRef.$refs.cmpyCdRef.kendoWidget().select(0)
        }
        if (this.$refs.cdGrupRef !== undefined) {
          this.$refs.cdGrupRef.kendoWidget().value('')
        }
        this.$refs.cdGrupNmRef.kendoWidget().value('')
        this.$refs.cdDescRef.kendoWidget().value('')
        this.$refs.useYnRef.kendoWidget().value(true)
        this.$refs.seqNoRef.kendoWidget().value(1)
        this.$refs.cdGrupEnRef.kendoWidget().value('')
        this.$refs.cdGrupZhRef.kendoWidget().value('')
        this.$refs.cdGrupVnRef.kendoWidget().value('')
        this.$refs.cdGrupJpRef.kendoWidget().value('')

        this.saveMode = 'INSERT'
        this.windowCmpyCd = ''
        this.windowSolCd = ''
        this.windowCdGrup = ''

        this.$parent.commonOnChangeEvent(this.saveMode)

      },
    },
  }
</script>

<style scoped>

</style>
